import { render, staticRenderFns } from "./SpaceInviteDialog.vue?vue&type=template&id=6e1957c8&scoped=true&"
import script from "./SpaceInviteDialog.vue?vue&type=script&lang=js&"
export * from "./SpaceInviteDialog.vue?vue&type=script&lang=js&"
import style0 from "./SpaceInviteDialog.vue?vue&type=style&index=0&id=6e1957c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1957c8",
  null
  
)

export default component.exports